import { render, staticRenderFns } from "./testPlanTable.vue?vue&type=template&id=b396121a"
import script from "./testPlanTable.vue?vue&type=script&lang=js"
export * from "./testPlanTable.vue?vue&type=script&lang=js"
import style0 from "./testPlanTable.vue?vue&type=style&index=0&id=b396121a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports